import React from 'react';
import { SEO } from '../components/SEO';
import { FaHardHat, FaTools, FaArrowLeft } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const EnConstruccion = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 flex items-center justify-center py-20">
      <SEO
        title="Sitio en Construcción | ECO SOFT"
        description="Esta sección está actualmente en construcción. Volveremos pronto con más contenido."
        name="EnConstruccion"
        type="website"
      />
      
      <div className="container mx-auto px-4 text-center">
        <div className="bg-white rounded-lg shadow-xl py-12 px-6 max-w-3xl mx-auto border-t-4 border-[#0066CC]">
          <div className="mb-8 flex justify-center">
            <div className="bg-[#0066CC]/10 rounded-full p-5 inline-block">
              <FaHardHat className="text-[#0066CC] text-5xl" />
            </div>
          </div>
          
          <h1 className="text-4xl font-bold mb-6 text-[#1A2B39]">Sitio en Construcción</h1>
          
          <div className="mb-8">
            <div className="h-2 w-24 bg-[#0066CC] mx-auto rounded-full"></div>
          </div>
          
          <p className="text-xl text-gray-600 mb-8 max-w-xl mx-auto">
            Estamos trabajando arduamente para mejorar esta sección del sitio.
            Volveremos pronto con nuevo contenido y mejoras.
          </p>
          
          <div className="flex items-center justify-center mb-8">
            <div className="flex space-x-3">
              <FaTools className="text-[#0066CC] animate-pulse text-3xl" />
              <span className="text-gray-500">Trabajando en ello...</span>
            </div>
          </div>
          
          <div className="mb-8">
            <h2 className="text-2xl font-bold mb-4 text-[#1A2B39]">¿Qué estamos mejorando?</h2>
            <ul className="text-left max-w-md mx-auto text-gray-600 space-y-2">
              <li className="flex items-start">
                <span className="text-[#0066CC] mr-2">✓</span>
                <span>Optimización del rendimiento</span>
              </li>
              <li className="flex items-start">
                <span className="text-[#0066CC] mr-2">✓</span>
                <span>Nueva experiencia de usuario</span>
              </li>
              <li className="flex items-start">
                <span className="text-[#0066CC] mr-2">✓</span>
                <span>Contenido actualizado</span>
              </li>
              <li className="flex items-start">
                <span className="text-[#0066CC] mr-2">✓</span>
                <span>Funcionalidades mejoradas</span>
              </li>
            </ul>
          </div>
          
          <div className="mt-10">
            <Link 
              to="/" 
              className="flex items-center justify-center gap-2 text-[#0066CC] hover:text-[#004a99] font-medium"
            >
              <FaArrowLeft /> Regresar a la página principal
            </Link>
          </div>
        </div>
        
        <div className="mt-12 text-gray-500">
          <p>Si necesitas información inmediata, por favor contáctanos:</p>
          <p className="font-medium">soporte@ecosoft.com.mx</p>
        </div>
      </div>
    </div>
  );
};

export default EnConstruccion; 